import { BadgeCheck, Building2, LockKeyhole, ShieldCheck, Timer } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useCompanyStatus } from "@/hooks/useCompanyStatus";
import { useTenant } from "@/hooks/useTenant";

const itemClass = "inline-flex items-center gap-1.5 whitespace-nowrap";

export const WorkspaceTrustBar = () => {
  const { isAuthenticated } = useAuth();
  const { data: tenant } = useTenant();
  const { isSuspended, isPastDue, isFreeTrial } = useCompanyStatus();

  if (!tenant && !isAuthenticated) return null;

  const trialLabel = (() => {
    if (isSuspended) return "Workspace suspended";
    if (isPastDue) return "Payment past due";
    if (isFreeTrial) return "Free trial";
    return "Active workspace";
  })();

  return (
    <section className="border-t border-border/40 bg-background px-4 text-xs text-muted-foreground">
      <div className="container mx-auto flex min-h-10 items-center gap-x-6 overflow-x-auto py-2">
        <span className={itemClass}>
          <Building2 className="h-3.5 w-3.5 text-primary" />
          {tenant?.company_name ? `${tenant.company_name} workspace` : "Company workspace"}
        </span>
        <span className={itemClass}>
          <LockKeyhole className="h-3.5 w-3.5 text-emerald-600" />
          {isAuthenticated ? "Secure session active" : "Sign in to start a secure session"}
        </span>
        <span className={itemClass}>
          <ShieldCheck className="h-3.5 w-3.5 text-emerald-600" />
          Data isolated by workspace
        </span>
        <span className={itemClass}>
          {isSuspended || isPastDue ? (
            <Timer className="h-3.5 w-3.5 text-destructive" />
          ) : (
            <BadgeCheck className="h-3.5 w-3.5 text-emerald-600" />
          )}
          {trialLabel}
        </span>
      </div>
    </section>
  );
};
